import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-mb-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_import_posts_btn = _resolveComponent("import-posts-btn")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, " Import posts from your " + _toDisplayString(_ctx.platform.name) + " account below. ", 1),
    _createVNode(_component_import_posts_btn, {
      platform: _ctx.platform,
      "client-id": _ctx.clientId,
      color: "primary",
      class: "q-mt-sm",
      rounded: ""
    }, null, 8, ["platform", "client-id"])
  ]))
}